import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { ButtonHTMLAttributes } from "react";

type TextButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: "white" | "black" | "primary";
  underline?: boolean;
  textCase?: "normal" | "uppercase" | "lowercase";
};

export function TextButton({
  className,
  children,
  color = "white",
  underline = false,
  textCase = "normal",
  type = "button",
  ...props
}: TextButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        textVariants.button,
        "h-11 w-full py-3 transition-colors duration-200 ease-out hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-60",
        {
          "text-os-brand": color === "primary",
          "text-white": color === "white",
          "text-black": color === "black",
          underline: underline,
          "!uppercase": textCase === "uppercase",
          "!lowercase": textCase === "lowercase",
          "!normal-case": textCase === "normal",
        },
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
